import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  errMsgCheckResponseQueryOption,
  majorNoticeQueryOption,
  useCustomMutation,
} from 'src/hooks/react-query/useCustomMutation.hook'
import { CouponCancelValidSpace, MajorNoticeSpace as mnspace } from 'src/types/api'

import { useChannel } from 'src/provider/ChannelContextProvider'
import { ERRCODES_COMMON } from 'src/service/constant/errcodes'
import { useGlobalStore } from 'src/store/zustand'

const useSystemNotice = () => {
  const { pathname } = useLocation()
  const { channel } = useChannel()
  const { setMaintenanceBlock, resetMaintenanceBlock } = useGlobalStore()
  const isMaintenanceBlock = false

  const { mutateAsync: noticeCheckMutate } = useCustomMutation<mnspace.Request, mnspace.Response>(
    majorNoticeQueryOption(),
  )

  const { mutateAsync: errMsgCheckMutate } = useCustomMutation<
    CouponCancelValidSpace.Request,
    CouponCancelValidSpace.Response
  >(errMsgCheckResponseQueryOption())

  const handleNoticeCheck = () => {
    // 스플래시 페이지에서는 공지사항 확인이 따로 존재함
    if (pathname.includes('splash')) return

    noticeCheckMutate({}).then(({ Header, Body: { Type } }) => {
      //시스템 점검 및 공지
      if (Type === 1) {
        if (!window.location.pathname?.includes('system_notice')) {
          window.location.replace(`${window.location.origin}/${channel}/system_notice`)
        }
      }
    })

    //TODO: 임시 api
    isMaintenanceBlock &&
      errMsgCheckMutate({ Idx: 1 }).then((res) => {
        const { ErrCode, ErrMsg } = res.Header
        if (ErrCode === ERRCODES_COMMON.SYSTEM_MAINTENANCE)
          setMaintenanceBlock({ t: '쿠폰 공급사 시스템 점검', d: ErrMsg })
        else resetMaintenanceBlock()
      })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(handleNoticeCheck, [pathname])
}
export default useSystemNotice
